<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-3">
						<label for="">Proveedor *</label>
                        <input type="text" v-model="MaterialProveedor.Proveedor" placeholder="Proveedor" class="form-control">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Proveedor" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
					</div>
					<div class="col-lg-3">
						<label for="">N° Parte Proveedor *</label>
                        <input type="text" v-model="MaterialProveedor.NoParteProveedor" placeholder="N° Parte Proveedor" class="form-control">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.NoParteProveedor" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
					</div>
					<div class="col-lg-3">
						<label for="">Precio</label>
                        <vue-numeric
                            class="form-control "
                            currency="$"
                            separator=","
                            placeholder="$0.00"
                            :precision="2"
                            v-model="MaterialProveedor.Precio"
                        ></vue-numeric>
					</div>
					<div class="col-lg-3">
						<label for="">Última Cotización</label>
                        <v-date-picker v-model="MaterialProveedor.UltimaCotizacion" :mode="typeCalendar"
                            :popover="{
                                placement: 'bottom',
                                visibility: 'click'
                            }"
                            :input-props="{
                                class: 'form-control cal-black',
                                style: 'cursor:pointer;'
                            }"
                            :locale="'es-MX'"
                        />
					</div>
				</div>
				<div class="row">
					<div class="col-lg-4">
						<label for="">Nombre Contacto *</label>
                        <input type="text" v-model="MaterialProveedor.NombreContacto" placeholder="Nombre Contacto" class="form-control">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.NombreContacto" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
					</div>
					<div class="col-lg-4">
						<label for="">Tipo Contacto *</label>
                        <input type="text" v-model="MaterialProveedor.TipoContacto" placeholder="Tipo Contacto" class="form-control">
                        <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.TipoContacto" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
					</div>
				</div>
			</template>
		</CLoader>
	</div>
</template>

<script>
export default {
	name:"FormProveedor",
	props:[
        "poBtnSave",
        "IdMaterial"
    ],
	data() {
		return {
			Modal:true,
            FormName:'Proveedores',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			MaterialProveedor:{
				IdMaterialProveedor:0,
				IdMaterial:0,
				Proveedor:'',
				NoParteProveedor:'',
				Precio:'',
				UltimaCotizacion:'',
				NombreContacto:'',
				TipoContacto:''
			},
			errorvalidacion:[],
		}
	},
	methods: {
		async Guardar(){
			let Fecha='';
			if (this.MaterialProveedor.UltimaCotizacion!='' && this.MaterialProveedor.UltimaCotizacion!=undefined) {
                let day=this.MaterialProveedor.UltimaCotizacion.getDate();
                let month=this.MaterialProveedor.UltimaCotizacion.getMonth()+1;
                let year=this.MaterialProveedor.UltimaCotizacion.getFullYear();
                Fecha=year+'-'+month+'-'+day;   
            }
			let formData=new FormData();
            formData.set('IdMaterialProveedor',this.MaterialProveedor.IdMaterialProveedor);
			formData.set('IdMaterial',this.IdMaterial);
			formData.set('Proveedor',this.MaterialProveedor.Proveedor);
			formData.set('NoParteProveedor',this.MaterialProveedor.NoParteProveedor);
			formData.set('Precio',this.MaterialProveedor.Precio);
			formData.set('UltimaCotizacion',Fecha);
			formData.set('NombreContacto',this.MaterialProveedor.NombreContacto);
			formData.set('TipoContacto',this.MaterialProveedor.TipoContacto);
			this.poBtnSave.toast=0;
            this.poBtnSave.disableBtn=true;
			await this.$http.post('materialproveedor/post',formData).then((res) => {
				this.poBtnSave.disableBtn=false; 
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion);
			}).catch((err) => {
				this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;
			})
		},
		Limpiar(){
			this.errorvalidacion=[];
			this.MaterialProveedor={
				IdMaterialProveedor:0,
				IdMaterial:0,
				Proveedor:'',
				NoParteProveedor:'',
				Precio:'',
				UltimaCotizacion:new Date(),
				NombreContacto:'',
				TipoContacto:''
			}
		},
		Recuperar(){
			this.$http.get('materialproveedor/recovery',{
				params:{
					IdMaterialProveedor:this.MaterialProveedor.IdMaterialProveedor
				}
			}).then((res) => {
				const objres=res.data.data.materialproveedor;
				this.MaterialProveedor.IdMaterialProveedor=objres.IdMaterialProveedor;
				this.MaterialProveedor.IdMaterial=objres.IdMaterial;
				this.MaterialProveedor.Proveedor=objres.Proveedor;
				this.MaterialProveedor.NoParteProveedor=objres.NoParteProveedor;
				this.MaterialProveedor.Precio=objres.Precio;
				this.MaterialProveedor.NombreContacto=objres.NombreContacto;
				this.MaterialProveedor.TipoContacto=objres.TipoContacto;
				let formatedDate = objres.UltimaCotizacion.replace(/-/g, "\/");
                this.MaterialProveedor.UltimaCotizacion=new Date(formatedDate);
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		}
	},
	created() {
		this.bus.$off("NewModal_"+this.EmitSeccion);
        this.bus.$on("NewModal_"+this.EmitSeccion,(data,Id)=>{
            this.ConfigLoad.ShowLoader=true;
            // this.Documento.IdActivo=this.IdActivo
            this.poBtnSave.disableBtn=false;
            this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
            this.Limpiar();
            if (Id > 0) {
				this.MaterialProveedor.IdMaterialProveedor = Id;
				this.Recuperar();
			}
            else{
                this.ConfigLoad.ShowLoader=false;
            }
			// this.GetActivos();
        });
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
